/**
 * @file src/components/templates/YieldBearingAssets/YieldBearingAssetsTemplate.tsx
 * @description This file defines the component for displaying a list of yield bearing assets.
 * It includes a back button, a heading, and a list of yield bearing assets.
 * @module YieldBearingAssetsTemplate
 */

import { FC } from 'react'; // Importing the Function Component type from React.
import { BackButton } from '@/components'; // Importing necessary UI components from the components directory.
import AllYieldBearingAssetsCard from '@/components/organisms/AllYieldBearingAssets/AllYieldBearingAssetsCard'; // Importing the AllYieldBearingAssetsCard component.

interface Props {
  onBack: () => void;
  onClickOnAsset: (asset: string) => void;
}

const YieldBearingAssetsTemplate: FC<Props> = ({
  onBack,
  onClickOnAsset: onClickOnAsset,
}) => {
  return (
    <div className="flex flex-col gap-md">
      <div className="w-auto">
        <BackButton onBackClick={onBack} />
      </div>
      <AllYieldBearingAssetsCard />
    </div>
  );
};

export default YieldBearingAssetsTemplate;
